<template>
  <div class="vx-row mb-2 mt-1">
    <div class="vx-col w-full"> 
        <span class="text-xs">{{fieldLabel}}</span>
      <vs-upload automatic name="file" :limit=structure.fileLimit fileName="file"  text="Upload" :action="uploadUrl" @on-success="successUpload" />
   
    </div>
  </div>
</template> 
<script>
import { sidebarMixin } from "../sidebarMixin";
export default {
    mixins: [sidebarMixin],
  props: { 
    baseUrl: String,
    uploadEndpoint: String,
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true
    },
    value: String,
    validation: ""
  },
  data() {
    return {
      localVal: "",
      name: ""
    };
  },
  computed:{
    
    uploadUrl(){
      console.log("baseurl:",this.baseUrl);
      return this.baseUrl + this.uploadEndpoint;
    }
  },
  methods: { 
    successUpload(event){ 

        this.localVal = event.currentTarget.response;
    },
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then(result => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
    onFileChanged(event) {
     
      const file = event.target.files[0];
      this.$emit("error", { index: this.index, value: true });
       this.$emit("input", { index: this.index, value: file });
    }
  },
  created() {
     console.log("create baseurl:",this.baseUrl);
    this.$emit("error", { index: this.index, value: true });
    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    this.localVal = this.value;

    this.$watch("localVal", value => {
      this.$emit("input", { index: this.index, value: value.replace('"','').replace('"','') });
       this.$emit("error", { index: this.index, value: true });
    });
  }
};
</script>